import type { MantineThemeOverride } from '@mantine/core';

export const Loader: MantineThemeOverride['components'] = {
	Loader: {
		defaultProps: (theme) => ({
			color: theme.other.getColor('icon/brand/default'),
		}),
	},
};
